/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../Input/Button/Button';
import PageNav from '../../JobComponents/Pagination/PageNav/PageNav';
import StickyAlertLayout from '../../Layout/StickyTopBar/StickyAlertLayout/StickyAlertLayout';
import SetAlertCallToAction from '../../CallToAction/SetAlertCallToAction/SetAlertCallToAction';
import StickyTopBar from '../../Layout/StickyTopBar/StickyTopBar';
import JobFiltersModal from '../../Modals/JobFiltersModal/JobFiltersModal';
import JobSearchFilter from '../JobSearchFilter/JobSearchFilter';
import JobList from '../../JobComponents/JobList/JobList';
import { JobContext, PageContext } from '../../../contexts/ContextCreator';
import { hasNext, hasPrev } from '../../Utilities/PaginationFunctions';
import {
    LOAD_TYPE_INFINITE_SCROLL,
    LOAD_TYPE_PAGINATION,
} from '../../../contexts/AbstractContext';
import InfiniteScrollWrapper from '../../Layout/InfiniteScrollWrapper/InfiniteScrollWrapper';
import JobResultsShineComponent from '../../ShineComponents/JobResultsShineComponent/JobResultsShineComponent';
import FeaturedCompanyAd from '../../CompanyAds/FeaturedCompanyAd/FeaturedCompanyAd';
import SetAlertButton from '../../Input/ButtonWithChildren/SetAlertButton/SetAlertButton';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import VirtualCareerFairCTA from '../VirtualCareerFairCTA/VirtualCareerFairCTA';

import './JobResultLayout.scss';

const loaderComponent = (
    <React.Fragment key="results-loader-shine">
        <JobResultsShineComponent />
        <JobResultsShineComponent />
    </React.Fragment>
);
/**
 * @deprecated
 */
class JobResultLayout extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showSticky: false,
            initialLoad: true,
        };
    }

    componentDidMount() {
        this.stickyAlertBar();
        window.addEventListener('scroll', this.stickyAlertBar);
        window.addEventListener('resize', this.stickyAlertBar);
        this.setIsLoading();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.stickyAlertBar);
        window.removeEventListener('resize', this.stickyAlertBar);
    }

    setStickyRef = (node) => {
        this.stickyBarLocation = node;
    };

    stickyAlertBar = () => {
        if (!this.stickyBarLocation) {
            return;
        }
        const stickyBarRef = this.stickyBarLocation.getBoundingClientRect();
        if (stickyBarRef.bottom <= 0) {
            if (!this.state.showSticky) {
                this.setState({ showSticky: true });
            }
        } else if (this.state.showSticky) {
            this.setState({ showSticky: false });
        }
    };

    setIsLoading = (initialLoad = false) => {
        this.setState({ initialLoad });
    };

    searchCanBeAlerted = () => {
        const { jobSearches, setAlertEnabled } = this.props;
        return (
            jobSearches &&
            jobSearches.jobSearchTerm &&
            jobSearches.jobLocation &&
            setAlertEnabled
        );
    };

    searchIsDisplayed = () => {
        const { jobSearches, setAlertEnabled } = this.props;
        return jobSearches && jobSearches.jobSearchTerm && setAlertEnabled;
    };

    hasNotPassedAlertLimit = () => {
        const { active } = this.props;
        const { followedJobAlerts } = this.context;
        return followedJobAlerts.length < 5 || active;
    };

    // TODO: remove legacy alert CTA
    getLegacyAlertCTA = () => {
        const { jobSearches, setAlertFunction, active } = this.props;

        const shouldShowAlertCTA =
            this.searchCanBeAlerted() && this.hasNotPassedAlertLimit();

        if (!shouldShowAlertCTA) return null;

        return (
            <SetAlertCallToAction
                jobSearches={jobSearches}
                onClick={setAlertFunction}
                active={active}
            />
        );
    };

    getFeaturedCompanyAd = () => {
        const { featuredCompany } = this.props;
        if (!featuredCompany) return null;

        return <FeaturedCompanyAd useCardShell={false} />;
    };

    renderZeroState = () => {
        const { featuredCompany } = this.props;

        return (
            <>
                {featuredCompany ? (
                    <FeaturedCompanyAd useCardShell={false} />
                ) : null}
            </>
        );
    };

    renderVcfAd = () => {
        const { showVcfAd, vcfAd } = this.props;

        if (!showVcfAd || !vcfAd) {
            return null;
        }

        const { name, desktop, mobile, url } = vcfAd;

        return (
            <VirtualCareerFairCTA
                cta={{
                    src: desktop,
                    mobileSrc: mobile,
                    alt: name,
                    url,
                }}
            />
        );
    };

    renderJobs = () => {
        const {
            renderType,
            isLoading,
            page,
            searchJobs,
            limit,
            jobsTotal,
        } = this.context;

        const isInfiniteScroll = renderType === LOAD_TYPE_INFINITE_SCROLL;
        const CompanyAdInsert = this.getFeaturedCompanyAd();
        const zeroStateComponent = this.renderZeroState();
        const staticInsert = {
            component: this.renderVcfAd(),
            insertedIndex: 5,
        };

        const repeatingInserts = [CompanyAdInsert];
        const hasOnlySinglePageOfResults = !!(jobsTotal <= limit);

        if (isInfiniteScroll) {
            return (
                <InfiniteScrollWrapper
                    className="infinite-job-list-wrapper"
                    pageStart={page}
                    loadMore={() => searchJobs(parseInt(page, 10) + 1)}
                    isLoading={isLoading}
                    loader={loaderComponent}
                    hasMore={
                        this?.context?.content?.length < this.context.jobsTotal
                    }
                    threshold={300}
                    useWindow
                >
                    <JobList
                        staticInsert={staticInsert}
                        repeatingInserts={repeatingInserts}
                        repeatingCadence={10}
                        zeroStateComponent={zeroStateComponent}
                        hasOnlySinglePageOfResults={hasOnlySinglePageOfResults}
                    />
                </InfiniteScrollWrapper>
            );
        }

        return (
            <JobList
                staticInsert={staticInsert}
                repeatingCadence={10}
                zeroStateComponent={zeroStateComponent}
            />
        );
    };

    renderSticky = () => {
        let stickyAlertBar = null;
        if (
            this.searchCanBeAlerted() &&
            this.hasNotPassedAlertLimit() &&
            this.state.showSticky
        ) {
            stickyAlertBar = (
                <StickyTopBar zIndex={200} className="purpleGradient">
                    <StickyAlertLayout
                        jobSearches={this.props.jobSearches}
                        active={this.props.active}
                        onClick={this.props.setAlertFunction}
                    />
                </StickyTopBar>
            );
        }

        return stickyAlertBar;
    };

    renderHeading = () => {
        const { jobSearches } = this.props;
        const { jobSearchTerm: jobTitle, jobLocation } = jobSearches;
        const hasJobTitle = !!(jobTitle && jobTitle.length > 0);
        const hasJobLocation = !!(jobLocation && jobLocation.length > 0);
        let jobText;
        switch (true) {
            case hasJobTitle && hasJobLocation:
                jobText = `${jobTitle} near ${jobLocation}:`;
                break;
            case hasJobTitle:
                jobText = `${jobTitle}:`;
                break;
            case hasJobLocation:
                jobText = `${jobLocation}:`;
                break;
            default:
                jobText = null;
        }

        return (
            (jobLocation || (jobTitle && jobTitle.length)) && (
                <div className="job-results__heading">
                    <h3 className="job-text__mobile-h3">
                        {truncateWithEllipsis(jobText, 50)}
                    </h3>
                    <h3 className="job-text__desktop-h3">
                        {truncateWithEllipsis(jobText, 67)}
                    </h3>
                </div>
            )
        );
    };

    renderResultsSummary = () => {
        const {
            setAlertFunction,
            active,
            jobSearches,
            title,
            shouldShowHelpText,
            showFilters,
        } = this.props;
        const { jobsTotal, activeFilters } = this.context;
        const showAddAlert =
            jobSearches.jobSearchTerm &&
            jobSearches.jobSearchTerm.length > 0 &&
            jobSearches.jobLocation &&
            this.hasNotPassedAlertLimit();

        // check if the filters are all empty arrays
        const isFiltered = !!Object.values(activeFilters).filter(
            (activeFilter) => activeFilter.length > 0
        ).length;
        const ModalWrapper = this.checkForFilters(isFiltered);

        const withFilterClassName = isFiltered ? ' show-active-filters' : '';

        const punctuation = jobsTotal ? ':' : '.';

        return (
            <div className="results-summary">
                <div className="results-content">
                    {this.renderHeading()}

                    <div data-qa="results">
                        <span className="header-text">{`${jobsTotal} ${title}${punctuation}`}</span>
                    </div>

                    {shouldShowHelpText && (
                        <p className="help-text">
                            To see all jobs, remove location and search.
                        </p>
                    )}
                </div>

                <div className={`results-buttons${withFilterClassName}`}>
                    {showAddAlert && (
                        <SetAlertButton
                            onClick={setAlertFunction}
                            active={active}
                        />
                    )}
                    {ModalWrapper}
                    {isFiltered && showFilters && <JobSearchFilter fixedMode />}
                </div>
            </div>
        );
    };

    checkForFilters = (isFiltered) => {
        if (this.props.showFilters && isFiltered) {
            return (
                <JobFiltersModal
                    renderButton={({ onClick }) => (
                        <div className="job-search-filter-edit-button-div">
                            <Button
                                type="purple-medium-white"
                                value="Edit"
                                onClick={onClick}
                            />
                        </div>
                    )}
                />
            );
        }
        if (this.props.showFilters && this.context.jobsTotal > 0) {
            return (
                <JobFiltersModal
                    renderButton={({ onClick }) => (
                        <div className="apply-filters-button-div">
                            <Button
                                type="secondary-blue-gray"
                                value="Apply Filters"
                                onClick={onClick}
                            />
                        </div>
                    )}
                />
            );
        }

        return null;
    };

    hasPaginationCheck = () => {
        return (
            this.context.renderType === LOAD_TYPE_PAGINATION &&
            (hasPrev(this.context.page) ||
                hasNext(
                    this.context.page,
                    this.context.limit,
                    this.context.jobsTotal
                ))
        );
    };

    renderPagination = () => {
        const prevPageHandler = hasPrev(this.context.page)
            ? () => this.context.searchJobs(parseInt(this.context.page, 10) - 1)
            : null;
        const nextPageHandler = hasNext(
            this.context.page,
            this.context.limit,
            this.context.jobsTotal
        )
            ? () => this.context.searchJobs(parseInt(this.context.page, 10) + 1)
            : null;
        return <PageNav prevUrl={prevPageHandler} nextUrl={nextPageHandler} />;
    };

    render() {
        const { initialLoad } = this.state;
        const { renderType } = this.context;

        const isInfiniteScroll = renderType === LOAD_TYPE_INFINITE_SCROLL;
        const showLoadingShine = initialLoad && isInfiniteScroll;

        return (
            <div className="component-JobV3-JobResultLayout">
                {this.renderResultsSummary()}
                <div className="divider" />
                {showLoadingShine ? (
                    <JobResultsShineComponent />
                ) : (
                    this.renderJobs()
                )}
                {this.hasPaginationCheck() && this.renderPagination()}
                {this.renderSticky()}
            </div>
        );
    }
}

export default React.memo((props) => {
    const { isLoggedIn, jobProfileSnippet } = React.useContext(PageContext);

    const userIsAuthenticated = isLoggedIn();
    const profileCompleted = jobProfileSnippet.isCompleted;

    const shouldHideProfileCTA = React.useMemo(() => {
        // bypass check below and hide CTA if explicity passed truthy prop
        if (props.hideJobResultsCTA) return true;

        // if the user is logged in and has completed their profile -> hide CTA
        return userIsAuthenticated && profileCompleted;
    }, [userIsAuthenticated, profileCompleted, props.hideJobResultsCTA]);

    return (
        <JobResultLayout {...props} hideJobResultsCTA={shouldHideProfileCTA} />
    );
});

JobResultLayout.contextType = JobContext;

JobResultLayout.propTypes = {
    /*
     * title
     */
    title: PropTypes.string.isRequired,
    /*
     * Whether or Not This Page shows the alert boxes or not (false if it's company job page, true if Search Results page)
     */
    setAlertEnabled: PropTypes.bool,
    /*
     * Set Alert On Click Function, required if setAlertEnabled
     */
    setAlertFunction: PropTypes.func,
    /*
     * Whether Button Is active, managed by parent page, required if setAlertEnabled
     */
    active: PropTypes.bool,
    /*
     * Job SErach INfo, required if setAlertEnabled
     */
    jobSearches: PropTypes.object,
    /**
     *  show results summary of filtered search
     */
    showFilters: PropTypes.bool,
    /**
     * show user help text to see all jobs
     */
    shouldShowHelpText: PropTypes.bool,
    vcfAd: PropTypes.object,
    featuredCompany: PropTypes.object,
    showVcfAd: PropTypes.bool,
};

JobResultLayout.defaultProps = {
    setAlertEnabled: false,
    setAlertFunction: () => {},
    active: false,
    jobSearches: {},
    showFilters: false,
    shouldShowHelpText: false,
    vcfAd: {},
    featuredCompany: {},
    showVcfAd: false,
};
